import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { Sorder } from '../models/entities/s-order';
import { SorderRequest } from '../models/dtos/sorder-request';
import { Sinvoice } from '../models/entities/s-invoice';
import { SinvoiceRequest } from '../models/dtos/sinvoice-request';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';


@Injectable({
    providedIn: 'root'
})
export class SalesTransactionsService {


    constructor(
        private networkService  : LeanNetworkService,
        public userService   : UserService) {
    }


    // SORDER SAVE
    //----------------------------------------------------------------------------------------------------------------------------------
   sorderSave(sorder : Sorder): Promise<Sorder> {
        let request : SorderRequest = new SorderRequest(this.userService.userInfo);
        request.sorder = sorder;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/sorderSave', request).then(result => {
                return resolve(result.sorder);
            }, error => {
                reject(error);
            });
        });
    }


    // SORDER SIMULATE
    //----------------------------------------------------------------------------------------------------------------------------------
    sorderSimulate(sorder : Sorder, promoCodes : string[]) : Promise<Sorder>{
        let request: SorderRequest = new SorderRequest(this.userService.userInfo);
        request.sorder = sorder;
        request.strings = promoCodes;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/sorderSimulate', request).then(result => {
                let sorder : Sorder= result.sorder;
                return resolve(sorder);
            }, error => {
                reject(error);
            });
        });
    }




    // SINVOIIE SAVE
    //----------------------------------------------------------------------------------------------------------------------------------
    sinvoiceCreate(sinvoice : Sinvoice): Promise<Sinvoice> {
        let request : SinvoiceRequest = new SinvoiceRequest(this.userService.userInfo);
        request.sinvoice = sinvoice;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/sinvoiceCreate', request).then(result => {
                return resolve(result.sinvoice);
            }, error => {
                reject(error);
            });
        });
    }


    // SORDER SIMULATE
    //----------------------------------------------------------------------------------------------------------------------------------
    sinvoiceSimulate(sinvoice : Sinvoice) : Promise<Sinvoice>{
        let request: SinvoiceRequest = new SinvoiceRequest(this.userService.userInfo);
        request.sinvoice = sinvoice;

        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/sinvoiceSimulate', request).then(result => {
                let sinvoice : Sinvoice = result.sinvoice;
                return resolve(sinvoice);
            }, error => {
                reject(error);
            });
        });
    }


    // SORDER GET
    //----------------------------------------------------------------------------------------------------------------------------------
    sordersGet(code : string, partnerCode : string, roleCode : string, d1 : Date, d2 : Date, excludeClosed : boolean, excludeCanceled  : boolean) : Promise<Sorder[]> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code; 
        request.strArg2 = partnerCode; 
        request.strArg3 = roleCode; 
        request.dteArg1 = d1;
        request.dteArg2 = d2;
        request.blnArg1 = excludeClosed;
        request.blnArg2 = excludeCanceled;
        
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/sordersGet', request).then(result => {
              return resolve(result.sorders);
            }, error => {
                reject(error);
            });
        });
      }

 
    // SORDER DETAIL
    //----------------------------------------------------------------------------------------------------------------------------------
     sorderGet(code : string) : Promise<Sorder> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;
        
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/sorderGet', request).then(result => {
                return resolve(result.sorder);
            }, error => {
                reject(error);
            });
        });
    }

    // SORDER CLOSE
    //----------------------------------------------------------------------------------------------------------------------------------
    sorderClose(code : string) : Promise<Sorder> {
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;
        
        return new Promise((resolve, reject) => {
          this.networkService.post('sales/transactions/sorderClose', request).then(result => {
              return resolve(result.sorder);
            }, error => {
                reject(error);
            });
        });
    }



    // Partners To Dispatch Get
    //----------------------------------------------------------------------------------------------------------------------------------
    partnersToDispatchGet(itinerarys: string[], salesChannelCode: string, partnerCategoryCode: string) : Promise<Partner[]>{
        let request         : BaseRequest = new BaseRequest(this.userService.userInfo);

        request.strings = itinerarys;
        request.strArg1 = salesChannelCode;
        request.strArg2 = partnerCategoryCode;
        
        return new Promise((resolve, reject) => {
            this.networkService.post('sales/transactions/partnersToDispatchGet', request).then(result => {
                return resolve(result.partners);
            }, error => {
                reject(error);
            });
        });
      }
}


